module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "p-bind container"
  }, [_c('el-row', {
    staticClass: "login-wrap"
  }, [_c('el-row', {
    staticClass: "bind-con"
  }, [_c('el-row', {
    staticClass: "bind-header"
  }, [_c('el-row', {
    staticClass: "bind-logo"
  }, [(_vm.logo_url) ? [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo_url,
      "alt": "",
      "width": "60px"
    }
  })] : [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo-fw.svg"),
      "alt": "",
      "width": "60px"
    }
  })]], 2), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('bind.page.title')))]), _vm._v(" "), (_vm.current_bind != 'bind_user') ? _c('p', {
    staticClass: "bind-text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('bind.page.description')) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "bind-content"
  }, [(_vm.current_bind == 'bind_user') ? _c('el-row', [_c('span', {
    staticClass: "bind-success"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bind-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('bind.bind_html', this.bindParams))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.current_bind == 'old_user') ? _c('el-row', [_c('el-form', {
    ref: "confirmForm",
    staticClass: "bind-form",
    attrs: {
      "model": _vm.confirmForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "app_name",
      "label": _vm.$t('common.application')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.confirmForm.app_name),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "app_name", $$v)
      },
      expression: "confirmForm.app_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('common.email')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.confirmForm.email),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "email", $$v)
      },
      expression: "confirmForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "bind-btns"
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmBind
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.bind')) + "\n                ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.current_bind == 'new_user') ? _c('el-row', [_c('el-form', {
    ref: "confirmForm",
    staticClass: "bind-form",
    attrs: {
      "model": _vm.confirmForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "app_name",
      "label": _vm.$t('common.application')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.confirmForm.app_name),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "app_name", $$v)
      },
      expression: "confirmForm.app_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('common.email')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.confirmForm.email),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "email", $$v)
      },
      expression: "confirmForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": _vm.$t('common.username')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('common.usernamePlaceholder')
    },
    model: {
      value: (_vm.confirmForm.username),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "confirmForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": _vm.$t('common.password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('common.passwordPlaceholder'),
      "readonly": _vm.readOnlyFlag
    },
    on: {
      "focus": function($event) {
        _vm.readOnlyFlag = false;
      }
    },
    model: {
      value: (_vm.confirmForm.password),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "password", $$v)
      },
      expression: "confirmForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "confirmPassword",
      "label": _vm.$t('common.confirmPassword')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('common.confirmPasswordPlaceholder'),
      "readonly": _vm.readOnlyFlag
    },
    on: {
      "focus": function($event) {
        _vm.readOnlyFlag = false;
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmBind($event)
      }
    },
    model: {
      value: (_vm.confirmForm.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "confirmPassword", $$v)
      },
      expression: "confirmForm.confirmPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "bind-btns"
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmBind
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.bind')) + "\n                ")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f29e6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BindUser.vue
// module id = 388
// module chunks = 1